/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Missmatchdefectp22Inputs */



/**
* | output |
* | --- |
* | "Left/high pump mismatch defect" |
*
* @param {Br_History_Key_Missmatchdefectp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_missmatchdefectp22 = /** @type {((inputs?: Br_History_Key_Missmatchdefectp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Missmatchdefectp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/high pump mismatch defect")
	return /** @type {LocalizedString} */ ("Défaut de descordance pompe gauche/haut")
});
export { br_history_key_missmatchdefectp22 as "br_history_key_missmatchDefectP2" }